
import genaration from '../../utils/classname';
var alertLess = {};
export var alertClass = genaration(alertLess, 'alert');